import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-navbar"
export default class extends Controller {
  static targets = [ "modal", "categories" ]

  connect() {
  }

  toggle(event) {
    const arrows = document.querySelectorAll('.mobile-nav-arrow');
    arrows.forEach(arrow => {
      arrow.classList.remove('active');
    });

    this.categoriesTargets.forEach((element, index) => {
      if (event.target.dataset.index == index) {
        if (element.style.display == 'none') {
          element.style.display = 'flex';
          event.target.children[1].classList.add("active");
        } else {
          element.style.display = 'none';
          event.target.children[1].classList.remove("active");
        }
      } else {
        element.style.display = 'none';
        // element.classList.remove("active");
      }
    })
  }

  close() {
    this.modalTarget.style.display = 'none';
  }

  open() {
    let target = document.querySelector('.mobile-navbar');
    target.style.display = 'block';
  }
}
